<div (click)="clearStorage()" class="logo">
  <p class="label2">
    7N
  </p>
</div>
